import {SpinnerBackgroundDefaultBox} from "./spinner-background.default.box";
import styled from "styled-components";

export const SpinnerBackgroundCasino777Box = styled(SpinnerBackgroundDefaultBox)`
  background-position: -1039px -70px;
  width: 250px;
  height: 215px;
  animation: none;
`;